module.exports = __webpack_public_path__ + "34e96c33396ee8352cb6d78f7071768a.svg";